/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { styled, Typography } from '@mui/material';
import SideBar from 'components/SideBar/SideBar';
import TopBar from 'components/TopBar/TopBar';
import { NAVIGATION_ROUTES } from 'constant/index';
import { IsMobile } from 'hooks/isMobile';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { isRunningInWebView } from 'utils/webviewHelpers';

const PageContainer = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  height: '100%'
}));

const Container = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
}));

const ContentContainer = styled('div')<{
  isWebViewPresent: boolean;
}>(({ isWebViewPresent }) => ({
  padding: '20px 20px',
  marginTop: isWebViewPresent ? '0px' : '72px',
  display: 'block',
  flex: 1,
  background: IsMobile() ? '#ffff' : '#f4f5f7'
}));

function PrivateRoute() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { isAuthenticated } = useSelector((state: any) => state.user);
  const isMobile = IsMobile();
  const isWebViewPresent = isRunningInWebView();
  const [openSideBar, setOpenSideBar] = useState(!isMobile);
  if (!isAuthenticated && !isWebViewPresent) {
    // not logged in so redirect to login page with the return url
    return <Navigate to={NAVIGATION_ROUTES.LOGIN} />;
  }

  // authorized so return child components
  return (
    <PageContainer>
      {!isMobile && (
        <SideBar setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />
      )}

      <Container>
        {!isWebViewPresent && (
          <TopBar setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />
        )}
        {isMobile && !isWebViewPresent && (
          <SideBar setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />
        )}
        <ContentContainer isWebViewPresent={isWebViewPresent}>
          <Outlet />
          <div
            style={{
              textAlign: 'center',
              width: '100%'
            }}
          >
            <Typography variant="Body1">Powered by Instavision</Typography>
          </div>
        </ContentContainer>
      </Container>
    </PageContainer>
  );
}

export default PrivateRoute;
